import { Component, Input, Output, EventEmitter } from '@angular/core';
import { INotification } from '@services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-item',
  standalone: false,
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss']
})
export class NotificationItemComponent {
  @Input() notification!: INotification;
  @Input() compact: boolean = false; // For dropdown view
  @Output() notificationClick = new EventEmitter<INotification>();

  constructor(private translateService: TranslateService) {}

  /**
   * Get title in current language
   */
  get title(): string {
    const lang = this.translateService.currentLang || 'en';
    if (lang === 'ar') {
      return this.notification.title.ar;
    }
    return this.notification.title.en || this.notification.title.ar;
  }

  /**
   * Get body in current language
   */
  get body(): string {
    const lang = this.translateService.currentLang || 'en';
    if (lang === 'ar') {
      return this.notification.body.ar;
    }
    return this.notification.body.en || this.notification.body.ar;
  }

  /**
   * Handle notification click
   */
  onClick(): void {
    this.notificationClick.emit(this.notification);
  }

  /**
   * Get time ago string
   */
  getTimeAgo(): string {
    const createdAt = new Date(this.notification.created_at);
    const now = new Date();
    const diffInMs = now.getTime() - createdAt.getTime();
    const diffInMinutes = Math.floor(diffInMs / 60000);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMinutes < 1) {
      return 'Just now';
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours}h ago`;
    } else if (diffInDays < 7) {
      return `${diffInDays}d ago`;
    } else {
      return createdAt.toLocaleDateString();
    }
  }
}
